import { z } from 'zod'

export const operationsQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  type: z.coerce.number().int().optional(),
  state: z.coerce.number().int().optional(),
  from: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD format')
    .optional(),
  to: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD format')
    .optional(),
})

export type OperationsQueryDto = z.infer<typeof operationsQuerySchema>
